import {merge} from 'lodash';
import Assessment from '../assessment';
import AssessmentResult from '../../../values/AssessmentResult';
import {META_TAG_POINTS, TITLE_WIDTH_ID} from '@axyseo/const/analysis';

/**
 * Represents the assessment that assesses the SEO title width and gives the feedback accordingly.
 */
export default class PageTitleWidthAssessment extends Assessment {
  /**
   * Sets the identifier and the config.
   *
   * @param {Object}  [config]        The configuration to use.
   *
   * @returns {void}
   */
  constructor(config = {}) {
    super();

    const defaultConfig = {
      id: TITLE_WIDTH_ID,
      fixPosition: 'meta title',
      docUrl:
        'https://docs.avada.io/seo-suite-help-center/seo-on-page-audit/checklist#meta-title-length-off-target',
      ctaType: 'fix',
      priority: 'high',
      title: 'Meta title width',
      content: {
        good: 'Title width is optimized, between 10 - 70 characters.',
        improve: '',
        bad:
          'Title too long or too short. Aim for 10-70 characters for best display in search results.'
      }
    };

    this.identifier = TITLE_WIDTH_ID;
    this._config = merge(defaultConfig, config);
  }

  /**
   * Runs the h1 research and based on this returns an assessment result with a score.
   *
   * @param {Paper}       paper       The paper to use for the assessment.
   * @param {Researcher}  researcher  The researcher used for calling the research.
   * @returns {AssessmentResult} The assessment result.
   */
  getResult({paper, researcher}) {
    const assessmentResult = new AssessmentResult({config: this._config});

    const calculatedResult = this.calculateResult(paper);

    assessmentResult.setScore(calculatedResult.score);
    assessmentResult.setStatus(calculatedResult.status);

    return assessmentResult;
  }

  /**
   *
   * @param paper
   * @returns {{score: number, status: string}}
   */
  calculateResult(paper) {
    const length = paper.getTitle().length;

    let status = 'bad';
    if (length <= 70 && length >= 10) {
      status = 'good';
    }
    const score = this.getScore(META_TAG_POINTS, status);

    return {
      score,
      status
    };
  }

  /**
   * Checks whether the paper has a text.
   *
   * @param {Paper}       paper       The paper to use for the assessment.
   *
   * @returns {boolean} True when there is text.
   */
  isApplicable(paper) {
    return true;
  }
}
